import ProductCategory from './product-category';//产样分类
import MemberVersion from './member-version';//用户版本
import VersionPermission from './version-permission';//版本权限
export default {
    ProductCategory,
    MemberVersion,
    VersionPermission

}